import fp from 'lodash/fp';

export const modalSelector = fp.compose(fp.defaultTo(''), fp.get('general.modal'));

export const scrollIsBottomSelector = fp.compose(
  fp.defaultTo(''),
  fp.get('general.scrollIsBottom')
);
